import { Link } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'
import './LandingNav.css'

interface Props { onStart: () => void }

export function LandingNav({ onStart }: Props) {
  return (
    <nav className="landing-nav">
      <div className="ln-inner">
        <Link to="/" className="ln-logo">
          <MessageSquare className="ln-logo-icon" size={22} />
          ChatArchiv.de
        </Link>
        <div className="ln-links">
          <a href="/#so-funktioniert">So geht's</a>
          <a href="/#preise">Preise</a>
          <button className="ln-cta" onClick={onStart}>Gratis testen</button>
        </div>
      </div>
    </nav>
  )
}
